"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSettingsFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M26.14 16a1.78 1.78 0 01.9-1.75l2.61-1.5-.23-.75a14.31 14.31 0 00-1.27-3 14.08 14.08 0 00-2-2.6l-.54-.58-2.54 1.49a1.77 1.77 0 01-2-.07A1.79 1.79 0 0120 5.58v-3l-.77-.18a14.1 14.1 0 00-6.46 0l-.77.17v3a1.76 1.76 0 01-1 1.67 1.78 1.78 0 01-2 .09L6.39 5.82l-.55.57A14.15 14.15 0 002.62 12l-.22.76L5 14.24A1.77 1.77 0 015.9 16a1.78 1.78 0 01-.9 1.75l-2.61 1.5.23.76A13.82 13.82 0 003.9 23a14 14 0 001.95 2.6l.54.58L9 24.69a1.77 1.77 0 012 .07 1.77 1.77 0 011 1.66v3l.77.18a14.37 14.37 0 003.26.38 13.72 13.72 0 003.2-.37l.77-.19v-3a1.78 1.78 0 011.06-1.69 1.79 1.79 0 012-.09l2.61 1.51.54-.57A14 14 0 0029.42 20l.23-.76-2.58-1.49a1.76 1.76 0 01-.93-1.75zm-12.62 4.33a5 5 0 116.84-1.83 5 5 0 01-6.84 1.83z" })));
}
exports.default = SvgSettingsFilled;
//# sourceMappingURL=SettingsFilled.js.map